import React from 'react';
import Container from '../Container';
import content from './privacyContent';

const PrivacyPolicy = () => (
  <Container heading="Privacy Policy">
    {content}
  </Container>
);

export default PrivacyPolicy;
